(function () {
  if (window.__ND_EXPORT_BRAND_HELPER__) return;
  window.__ND_EXPORT_BRAND_HELPER__ = true;

  function getBrandMap() {
    return window.ND_EXPORT_BRAND_MAP || { default: {}, tags: {} };
  }

  function getCustomerTags() {
    try {
      if (!Array.isArray(window.ND_CUSTOMER_TAGS)) return [];
      return window.ND_CUSTOMER_TAGS
        .map(v => String(v || '').trim().toLowerCase())
        .filter(Boolean);
    } catch (e) {
      console.warn('[ND Brand] getCustomerTags failed', e);
      return [];
    }
  }

  function getExportBrand() {
    const map = getBrandMap();
    const tags = getCustomerTags();
    const tagMap = map.tags || {};

    const brandTag = tags.find(tag => tag.startsWith('export-brand:'));
    if (brandTag && tagMap[brandTag] && tagMap[brandTag].enabled) {
      const hit = tagMap[brandTag];
      return {
        key: brandTag,
        enabled: true,
        logoUrl: hit.logoUrl || ''
      };
    }

    const d = map.default || {};
    return {
      key: 'default',
      enabled: !!d.enabled,
      logoUrl: d.logoUrl || ''
    };
  }

  async function loadImageAsDataURL(url) {
    if (!url) return '';
    try {
      const res = await fetch(url, { mode: 'cors' });
      const blob = await res.blob();
      return await new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onloadend = () => resolve(fr.result || '');
        fr.onerror = reject;
        fr.readAsDataURL(blob);
      });
    } catch (err) {
      console.warn('[ND Brand] loadImageAsDataURL failed', err);
      return '';
    }
  }

  async function getExportBrandWithLogoData() {
    const brand = getExportBrand();
    const logoDataUrl = await loadImageAsDataURL(brand.logoUrl);
    return Object.assign({}, brand, { logoDataUrl });
  }

  window.ND_getExportBrand = getExportBrand;
  window.ND_getExportBrandWithLogoData = getExportBrandWithLogoData;
})();